
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/subscription-based-vs-traditional",
      function () {
        return require("private-next-pages/articles/subscription-based-vs-traditional.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/subscription-based-vs-traditional"])
      });
    }
  